(function($) {
  $.extend($.summernote.lang, {
    'fr-FR': {
      font: {
        bold: 'Gras',
        italic: 'Italique',
        underline: 'Souligné',
        clear: 'Effacer la mise en forme',
        height: 'Interligne',
        name: 'Famille de police',
        strikethrough: 'Barré',
        superscript: 'Exposant',
        subscript: 'Indice',
        size: 'Taille de police',
      },
      image: {
        image: 'Image',
        insert: 'Insérer une image',
        resizeFull: 'Taille originale',
        resizeHalf: 'Redimensionner à 50 %',
        resizeQuarter: 'Redimensionner à 25 %',
        floatLeft: 'Aligné à gauche',
        floatRight: 'Aligné à droite',
        floatNone: 'Pas d\'alignement',
        shapeRounded: 'Forme: Rectangle arrondi',
        shapeCircle: 'Forme: Cercle',
        shapeThumbnail: 'Forme: Vignette',
        shapeNone: 'Forme: Aucune',
        dragImageHere: 'Faites glisser une image ou un texte dans ce cadre',
        dropImage: 'Lachez l\'image ou le texte',
        selectFromFiles: 'Choisir un fichier',
        maximumFileSize: 'Taille de fichier maximale',
        maximumFileSizeError: 'Taille maximale du fichier dépassée',
        url: 'URL de l\'image',
        remove: 'Supprimer l\'image',
        original: 'Original',
      },
      video: {
        video: 'Vidéo',
        videoLink: 'Lien vidéo',
        insert: 'Insérer une vidéo',
        url: 'URL de la vidéo',
        providers: '(YouTube, Google Drive, Vimeo, Vine, Instagram, DailyMotion or Youku)',
      },
      link: {
        link: 'Lien',
        insert: 'Insérer un lien',
        unlink: 'Supprimer un lien',
        edit: 'Modifier',
        textToDisplay: 'Texte à afficher',
        url: 'URL du lien',
        openInNewWindow: 'Ouvrir dans une nouvelle fenêtre',
        useProtocol: 'Utiliser le protocole par défaut',
      },
      table: {
        table: 'Tableau',
        addRowAbove: 'Ajouter une ligne au-dessus',
        addRowBelow: 'Ajouter une ligne en dessous',
        addColLeft: 'Ajouter une colonne à gauche',
        addColRight: 'Ajouter une colonne à droite',
        delRow: 'Supprimer la ligne',
        delCol: 'Supprimer la colonne',
        delTable: 'Supprimer le tableau',
      },
      hr: {
        insert: 'Insérer une ligne horizontale',
      },
      style: {
        style: 'Style',
        p: 'Normal',
        blockquote: 'Citation',
        pre: 'Code source',
        h1: 'Titre 1',
        h2: 'Titre 2',
        h3: 'Titre 3',
        h4: 'Titre 4',
        h5: 'Titre 5',
        h6: 'Titre 6',
      },
      lists: {
        unordered: 'Liste à puces',
        ordered: 'Liste numérotée',
      },
      options: {
        help: 'Aide',
        fullscreen: 'Plein écran',
        codeview: 'Afficher le code HTML',
      },
      paragraph: {
        paragraph: 'Paragraphe',
        outdent: 'Diminuer le retrait',
        indent: 'Augmenter le retrait',
        left: 'Aligner à gauche',
        center: 'Centrer',
        right: 'Aligner à droite',
        justify: 'Justifier',
      },
      color: {
        recent: 'Dernière couleur sélectionnée',
        more: 'Plus de couleurs',
        background: 'Couleur de fond',
        foreground: 'Couleur de police',
        transparent: 'Transparent',
        setTransparent: 'Définir la transparence',
        reset: 'Restaurer',
        resetToDefault: 'Restaurer la couleur par défaut',
      },
      shortcut: {
        shortcuts: 'Raccourcis',
        close: 'Fermer',
        textFormatting: 'Mise en forme du texte',
        action: 'Action',
        paragraphFormatting: 'Mise en forme des paragraphes',
        documentStyle: 'Style du document',
        extraKeys: 'Touches supplémentaires',
      },
      help: {
        'insertParagraph': 'Insérer paragraphe',
        'undo': 'Défaire la dernière commande',
        'redo': 'Refaire la dernière commande',
        'tab': 'Tabulation',
        'untab': 'Tabulation arrière',
        'bold': 'Mettre en caractère gras',
        'italic': 'Mettre en italique',
        'underline': 'Mettre en souligné',
        'strikethrough': 'Mettre en texte barré',
        'removeFormat': 'Nettoyer les styles',
        'justifyLeft': 'Aligner à gauche',
        'justifyCenter': 'Centrer',
        'justifyRight': 'Aligner à droite',
        'justifyFull': 'Justifier à gauche et à droite',
        'insertUnorderedList': 'Basculer liste à puces',
        'insertOrderedList': 'Basculer liste ordonnée',
        'outdent': 'Diminuer le retrait du paragraphe',
        'indent': 'Augmenter le retrait du paragraphe',
        'formatPara': 'Changer le paragraphe en cours en normal (P)',
        'formatH1': 'Changer le paragraphe en cours en entête H1',
        'formatH2': 'Changer le paragraphe en cours en entête H2',
        'formatH3': 'Changer le paragraphe en cours en entête H3',
        'formatH4': 'Changer le paragraphe en cours en entête H4',
        'formatH5': 'Changer le paragraphe en cours en entête H5',
        'formatH6': 'Changer le paragraphe en cours en entête H6',
        'insertHorizontalRule': 'Insérer séparation horizontale',
        'linkDialog.show': 'Afficher fenêtre d\'hyperlien',
      },
      history: {
        undo: 'Annuler la dernière action',
        redo: 'Restaurer la dernière action annulée',
      },
      specialChar: {
        specialChar: 'Caractères spéciaux',
        select: 'Choisir des caractères spéciaux',
      },
    },
  });
})(jQuery);
